module.exports = __webpack_public_path__ + "static/media/id.a170c4c3.mp3";